import React, { Component } from "react";
import {
  Container,
  Image,
  Modal,
  Button,
  Form,
  Dropdown,
  Row,
  Col,
  DropdownButton,
  Pagination,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import LogoImage from "../../Images/logo-wirebit-transfer.png";
import { store } from "react-notifications-component";
import NumberFormat from "react-number-format";
import { Bounce } from "react-activity";

import Backend from "../../Backend";
import Connection from "../../Calls";

import flechitas from "../../Images/Transfer-03.png";
import logoCuadrado from "../../Images/LogoWirebitTransfer_Azul.png";
import logoPlano from "../../Images/LogoWirebitTransfer-03.png";
import arrowDown from "../../Images/arrow-down.svg";
import GAuth from "../../Images/gauth.png";

import Modaltwofa from "../2fa/index";
import "../2fa/index.css";

import ExternalTransferConfirmation from "./ExternalTransferConfirmation/ExternalTransferConfirmation";

function formatMoney(n, c, d, t) {
  var n = n,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
}

export default class TransferModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coins: [],
      wallets: [],
      tab: new window.URL(window.location.href).searchParams.get("alias")
        ? "external"
        : "internal",
      fromWallet: "",
      toWallet: "",
      amountW:
        new window.URL(window.location.href).searchParams.get("amount") || "",
      selectedCurrency:
        new window.URL(window.location.href).searchParams.get("currency") || "",
      description:
        new window.URL(window.location.href).searchParams.get("description") ||
        "",
      toAccount:
        new window.URL(window.location.href).searchParams.get("alias") || "",
      toAlias:
        new window.URL(window.location.href).searchParams.get("wallet") || "",
      TWOfa: "",
      showModalTwofa: false,
      twofa_code: "-",
      amountCp: "",
      intenalFee: "",
      accountFee: "",
    };
    this.TowFAConfirm = this.TowFAConfirm.bind(this);
  }

  TowFAConfirm(code) {
    this.setState({ twofa_code: code, showModalTwofa: false });
    if (code != "cancel") this.sendTransferUser();
  }

  componentWillMount() {
    this.getWallets(1, 100000, "");
    this.getCoins();
    this.getFee();
  }
  getFee() {
    this.setState({
      intenalFee: (100 - this.props.planInfo.transfer_internal) / 100,
      accountFee: (100 - this.props.planInfo.transfer_users_web) / 100,
    });
  }

  getWallets(value_paginaActual, value_numeroFilas, valueSearch) {
    const self = this;
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Backend.Check2FA(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              if (response.payload.status === "enabled") {
                this.setState({ TWOfa: true });
              } else {
                this.setState({ TWOfa: false });
              }
            } else {
            }
          }
        );
        Backend.GetWallets(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          valueSearch,
          value_paginaActual,
          value_numeroFilas,
          response.payload.r01,
          (response) => {
            if (response.status.code === "0") {
              if (
                new window.URL(window.location.href).searchParams.get(
                  "currency"
                )
              ) {
                var wallets = [];
                response.payload.forEach((item, i) => {
                  if (
                    item.coin ==
                    new window.URL(window.location.href).searchParams.get(
                      "currency"
                    )
                  )
                    wallets.push(item);
                });
                this.preselectWallet(wallets[0]);
                self.setState({
                  wallets: wallets,
                  dataLength: wallets.length,
                });
              } else {
                self.setState({
                  wallets: response.payload,
                  dataLength: response.payload.length,
                });
              }
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            }
            self.setState({ showload: false });
          }
        );
      }
    );
  }

  getCoins() {
    const self = this;
    Backend.DropdownCoin((response) => {
      if (response.status.code === "0") {
        self.setState({
          coins: response.payload,
        });
      }
    });
  }

  renderListCoins(value) {
    var item;
    this.state.coins.forEach((element) => {
      if (element.symbol.toLowerCase() === value.toLowerCase()) {
        item = element.name;
      }
    });
    return item;
  }

  selectWallet(wallet) {
    this.props.coinArr.forEach((item, i) => {
      if (item.symbol == wallet.coin) {
        this.setState({
          fromWallet: wallet,
          toWallet: "",
          selectedCurrency: wallet.coin,
          usdPrice: item.usd_price,
        });
      }
    });
  }

  preselectWallet(wallet) {
    if (wallet != null) {
      this.setState({ fromWallet: wallet });
      if (this.props.coinArr) {
        this.props.coinArr.forEach((item, i) => {
          if (item.symbol == wallet.coin) {
            this.setState({ usdPrice: item.usd_price });
          }
        });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "You have no available wallets for this coin",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
    }
  }
  renderListWallets() {
    const self = this;
    var wallets = [];
    self.state.wallets.forEach(function (item) {
      wallets.push(
        <Dropdown.Item onClick={() => self.selectWallet(item)} as="button">
          <Image
            src={require("../../CryptoIcons/" + item.coin + ".svg")}
            style={{ width: 15, marginTop: -4, marginRight: 5 }}
          />
          {item.alias}:{" "}
          <label style={{ fontWeight: "bold", marginBottom: 0 }}>
            {Number(item.balance).toFixed(8)}{" "}
          </label>{" "}
          <label style={{ textTransform: "uppercase", marginBottom: 0 }}>
            {item.coin}
          </label>
        </Dropdown.Item>
      );
    });
    return wallets;
  }

  renderListWalletsTo() {
    const self = this;
    var wallets = [];
    self.state.wallets.forEach(function (item) {
      if (
        item.alias != self.state.fromWallet.alias &&
        item.coin === self.state.selectedCurrency
      )
        wallets.push(
          <Dropdown.Item
            onClick={() => {
              self.setState({ toWallet: item });
            }}
            as="button"
          >
            <Image
              src={require("../../CryptoIcons/" + item.coin + ".svg")}
              style={{ width: 15, marginTop: -4, marginRight: 5 }}
            />
            {item.alias}:{" "}
            <label style={{ fontWeight: "bold", marginBottom: 0 }}>
              {Number(item.balance).toFixed(8)}{" "}
            </label>{" "}
            <label style={{ textTransform: "uppercase", marginBottom: 0 }}>
              {item.coin}
            </label>
          </Dropdown.Item>
        );
    });
    return wallets;
  }

  cryptoSend(value) {
    var calculoCrypto;
    if (this.state.selectedCurrency == "usd") {
      var calculoCrypto = (value / this.state.usdPrice).toFixed(8);
    } else {
      var calculoCrypto = value;
    }
    this.setState({
      amountW: value,
      cryptoSend: calculoCrypto,
    });
  }

  calculateCrypto() {
    var calculoCrypto;
    if (this.state.selectedCurrency == "usd") {
      var calculoCrypto = (
        (this.state.amountW *
          (1 - this.props.planInfo.transfer_internal / 100)) /
        this.state.usdPrice
      ).toFixed(8);
    } else {
      var calculoCrypto = (
        this.state.amountW *
        (1 - this.props.planInfo.transfer_internal / 100)
      ).toFixed(8);
    }
    return calculoCrypto;
  }

  calculateCryptoAccount() {
    var calculoCrypto;
    if (this.state.selectedCurrency == "usd") {
      var calculoCrypto = (
        (this.state.amountW *
          (1 - this.props.planInfo.transfer_users_web / 100)) /
        this.state.usdPrice
      ).toFixed(8);
    } else {
      var calculoCrypto = (
        this.state.amountW *
        (1 - this.props.planInfo.transfer_users_web / 100)
      ).toFixed(8);
    }
    return calculoCrypto;
  }

  calculateUSD() {
    var calculoUsd;
    if (this.state.selectedCurrency == "usd") {
      var calculoUsd = (
        this.state.amountW *
        (1 - Number(this.props.planInfo.transfer_internal) / 100)
      ).toFixed(2);
    } else {
      var amountFee =
        Number(this.props.planInfo.transfer_internal) == 0
          ? this.state.amountW
          : this.state.amountW *
            (1 - Number(this.props.planInfo.transfer_internal) / 100);
      var calculoUsd = formatMoney(amountFee * this.state.usdPrice);
    }
    return calculoUsd;
  }

  calculateUSDAccount() {
    var calculoUsd;
    if (this.state.selectedCurrency == "usd") {
      var calculoUsd = (
        this.state.amountW *
        (1 - Number(this.props.planInfo.transfer_users_web) / 100)
      ).toFixed(2);
    } else {
      var amountFee =
        Number(this.props.planInfo.transfer_users_web) == 0
          ? this.state.amountW
          : this.state.amountW *
            (1 - Number(this.props.planInfo.transfer_users_web) / 100);
      var calculoUsd = formatMoney(amountFee * this.state.usdPrice);
    }
    return calculoUsd;
  }

  sendTransfer() {
    const self = this;
    self.setState({ showload: true });

    if (
      this.state.fromWallet == "" ||
      this.state.toWallet == "" ||
      this.state.amountW == "" ||
      this.state.amountW == undefined ||
      this.state.passwordW == "" ||
      this.state.passwordW == undefined
    ) {
      store.addNotification({
        title: "Error!",
        message: "Please fill out all requeired fields",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({ showload: false });

      return;
    }
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    let whiskas = Connection.RThzHrsb(this.state.passwordW);
    let combination2 = Connection.RThzHrsb("XWBX203");
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Connection.QCJQ7DUk(
          confirmation,
          date,
          result,
          "Apxm2aZ",
          combination2,
          "XWBX203",
          "2",
          whiskas,
          (callback) => {
            var amountToSend =
              self.state.selectedCurrency === "usd"
                ? self.calculateCrypto()
                : self.state.amountW;

            Backend.InternalTransfer(
              localStorage.getItem("email"),
              localStorage.getItem("token"),
              callback.payload.r03,
              this.state.fromWallet.id_wallet,
              this.state.toWallet.id_wallet,
              this.state.cryptoSend,
              response.payload.r01,
              "-",
              (response) => {
                if (response.status.code === "0") {
                  store.addNotification({
                    title: "Success!",
                    message: "Transfer successful",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true,
                    },
                  });
                  self.setState(
                    {
                      selectedCurrency: "",
                      fromWallet: "",
                      toWallet: "",
                      toAccount: "",
                      toAlias: "",
                      passwordW: "",
                      description: "",
                      amountW: 0,
                    },
                    () => {
                      this.props.handleClose();
                      this.props.refresher();
                    }
                  );
                } else {
                  store.addNotification({
                    title: "Error!",
                    message: response.status.description,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true,
                    },
                  });
                }
                self.setState({ showload: false });
              }
            );
          }
        );
      }
    );
  }

  handleoGoToConfirmTransfer() {
    if (
      this.state.fromWallet == "" ||
      this.state.toAccount == "" ||
      this.state.toAlias == "" ||
      this.state.amountW == "" ||
      this.state.amountW == undefined ||
      this.state.passwordW == "" ||
      this.state.passwordW == undefined ||
      this.state.toAccount == undefined ||
      this.state.toAlias == undefined ||
      this.state.description == "" ||
      this.state.description == undefined
    ) {
      store.addNotification({
        title: "Error!",
        message: "Please fill out all requeired fields",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      return;
    } else {
      this.setState({ tab: "external_confirmation" });
    }
  }

  verifyTwofa() {
    if (this.state.TWOfa) {
      this.setState({ showModalTwofa: true });
    } else {
      this.sendTransferUser();
    }
  }

  sendTransferUser() {
    const self = this;
    self.setState({ showload: true }); //this.state.toAlias, this.state.description
    if (
      this.state.fromWallet == "" ||
      this.state.toAccount == "" ||
      this.state.toAlias == "" ||
      this.state.amountW == "" ||
      this.state.amountW == undefined ||
      this.state.passwordW == "" ||
      this.state.passwordW == undefined ||
      this.state.toAccount == undefined ||
      this.state.toAlias == undefined ||
      this.state.description == "" ||
      this.state.description == undefined
    ) {
      store.addNotification({
        title: "Error!",
        message: "Please fill out all requeired fields",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true,
        },
      });
      self.setState({ showload: false });
      return;
    }
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    let whiskas = Connection.RThzHrsb(this.state.passwordW);
    let combination2 = Connection.RThzHrsb("XWBX203");
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        Connection.QCJQ7DUk(
          confirmation,
          date,
          result,
          "Apxm2aZ",
          combination2,
          "XWBX203",
          "2",
          whiskas,
          (callback) => {
            var amountToSend =
              self.state.selectedCurrency === "usd"
                ? self.calculateCrypto()
                : self.state.amountW;

            Backend.UserTransfer(
              localStorage.getItem("email"),
              localStorage.getItem("token"),
              callback.payload.r03,
              this.state.fromWallet.id_wallet,
              this.state.cryptoSend,
              this.state.toAccount,
              this.state.toAlias,
              this.state.description,
              response.payload.r01,
              self.state.twofa_code,
              (response) => {
                if (response.status.code === "0") {
                  store.addNotification({
                    title: "Success!",
                    message: "Transfer successful",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true,
                    },
                  });
                  self.setState(
                    {
                      selectedCurrency: "",
                      fromWallet: "",
                      toWallet: "",
                      toAccount: "",
                      toAlias: "",
                      passwordW: "",
                      description: "",
                      amountW: 0,
                      tab: "external",
                    },
                    () => {
                      this.props.handleClose();
                      this.props.refresher();
                    }
                  );
                } else {
                  store.addNotification({
                    title: "Error!",
                    message: response.status.description,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                      duration: 1800,
                      onScreen: true,
                    },
                  });
                }
                self.setState({ showload: false });
              }
            );
          }
        );
      }
    );
  }

  contentManager() {
    switch (this.state.tab) {
      case "internal":
        return (
          <div className="container-steps-add-wallet-general">
            <div>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image src={logoCuadrado} style={{ width: "25%" }} />
              </Row>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "baseline",
                  marginTop: 20,
                }}
              >
                <Col md={5} className="virtual_exchange_dropdown">
                  <Form.Label className="virtual_exchange_information_wallets_text">
                    {" "}
                    {
                      this.props.traductions.wallets.Index.modalTransfers
                        .L_FromWallets
                    }
                    :
                  </Form.Label>
                  <Dropdown
                    title={
                      this.state.fromWallet
                        ? this.state.fromWallet.alias
                        : this.props.traductions.wallets.Index.modalTransfers
                            .S_Wallets
                    }
                  >
                    <Dropdown.Toggle id="dropdown-custom-1">
                      {this.state.fromWallet ? (
                        <>
                          <Image
                            src={require("../../CryptoIcons/" +
                              this.state.fromWallet.coin +
                              ".svg")}
                            style={{ width: 15, marginTop: -4, marginRight: 5 }}
                          />
                          {this.state.fromWallet.alias}:{" "}
                          <label
                            style={{ fontWeight: "bold", marginBottom: 0 }}
                          >
                            {Number(this.state.fromWallet.balance).toFixed(8)}{" "}
                          </label>{" "}
                          <label
                            style={{
                              textTransform: "uppercase",
                              marginBottom: 0,
                            }}
                          >
                            {this.state.fromWallet.coin}
                          </label>
                        </>
                      ) : (
                        this.props.traductions.wallets.Index.modalTransfers
                          .S_Wallets
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>{this.renderListWallets()}</Dropdown.Menu>
                  </Dropdown>
                </Col>
                {/* <Col md={1}>
                <center><Image src={flechitas} style={{width:'50%', marginTop:'1.5em'}}/></center>
              </Col> */}
                <Col md={5} className="virtual_exchange_dropdown">
                  <Form.Label className="virtual_exchange_information_wallets_text">
                    {
                      this.props.traductions.wallets.Index.modalTransfers
                        .L_ToWallets
                    }
                  </Form.Label>
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-custom-1">
                      {this.state.toWallet ? (
                        <>
                          <Image
                            src={require("../../CryptoIcons/" +
                              this.state.toWallet.coin +
                              ".svg")}
                            style={{ width: 15, marginTop: -4, marginRight: 5 }}
                          />
                          {this.state.toWallet.alias}:{" "}
                          <label
                            style={{ fontWeight: "bold", marginBottom: 0 }}
                          >
                            {Number(this.state.toWallet.balance).toFixed(8)}{" "}
                          </label>{" "}
                          <label
                            style={{
                              textTransform: "uppercase",
                              marginBottom: 0,
                            }}
                          >
                            {this.state.toWallet.coin}
                          </label>
                        </>
                      ) : (
                        this.props.traductions.wallets.Index.modalTransfers
                          .S_Wallets
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>{this.renderListWalletsTo()}</Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
                {this.state.fromWallet && this.props.planInfo ? (
                  <Col sm={{ span: 8, offset: 2 }}>
                    <p className="text-available-modal">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_AmountAvl
                      }
                      : {this.state.fromWallet.balance}{" "}
                      {this.state.fromWallet.coin}
                    </p>
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm="2"
                        className="virtual_exchange_information_wallets_text"
                      >
                        {
                          this.props.traductions.wallets.Index.modalTransfers
                            .L_Amount
                        }
                      </Form.Label>
                      <Col sm="10" className="virtual_exchange_dropdown">
                        <div
                          className="input-signup"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {this.state.selectedCurrency == "usd" ? (
                            <NumberFormat
                              className="btc-format-input"
                              placeholder="USD Amount"
                              decimalScale={2}
                              thousandSeparator={true}
                              prefix={"$"}
                              value={this.state.amountW}
                              onValueChange={(values) => {
                                const { formattedValue, value } = values;
                                this.cryptoSend(value);
                              }}
                            />
                          ) : (
                            <NumberFormat
                              className="btc-format-input"
                              placeholder={
                                this.state.fromWallet.coin.toUpperCase() +
                                " Amount"
                              }
                              decimalScale={8}
                              value={this.state.amountW}
                              onValueChange={(values) => {
                                const { formattedValue, value } = values;
                                this.cryptoSend(value);
                              }}
                            />
                          )}
                          <Button
                            className={
                              this.state.selectedCurrency ===
                              this.state.fromWallet.coin
                                ? "boton-seleccionar-currency-selected"
                                : "boton-seleccionar-currency"
                            }
                            variant="link"
                            onClick={() => {
                              this.setState({
                                selectedCurrency: this.state.fromWallet.coin,
                              });
                            }}
                          >
                            {this.state.fromWallet.coin.toUpperCase()}
                          </Button>
                          <Button
                            className={
                              this.state.selectedCurrency === "usd"
                                ? "boton-seleccionar-currency-selected"
                                : "boton-seleccionar-currency"
                            }
                            variant="link"
                            onClick={() => {
                              this.setState({ selectedCurrency: "usd" });
                            }}
                          >
                            USD
                          </Button>
                        </div>
                        <div
                          className={
                            this.state.amountW
                              ? "container-addresses-label"
                              : "container-addresses-label-error"
                          }
                        >
                          <p
                            className={
                              !this.state.amountW
                                ? "label-addresses-captured-success"
                                : "label-addresses-captured-warning"
                            }
                            style={{ marginBottom: 2 }}
                          >
                            {
                              this.props.traductions.wallets.Index
                                .modalTransfers.N_Amount1
                            }{" "}
                            {Number(
                              this.calculateCrypto() * this.state.intenalFee
                            ).toFixed(8)}{" "}
                            {this.state.fromWallet.coin} (
                            {Number(
                              this.props.planInfo.transfer_internal
                            ).toFixed(0)}
                            %{" "}
                            {
                              this.props.traductions.wallets.Index
                                .modalTransfers.N_Amount2
                            }
                            )
                          </p>
                          <p
                            className={
                              !this.state.amountW
                                ? "label-addresses-captured-success"
                                : "label-addresses-captured-warning"
                            }
                          >
                            {
                              this.props.traductions.wallets.Index
                                .modalTransfers.N_Amount3
                            }{" "}
                            {this.calculateUSD()} usd
                          </p>
                        </div>
                      </Col>
                    </Form.Group>
                  </Col>
                ) : (
                  <Col sm={{ span: 8, offset: 2 }}>
                    <p className="text-available-modal">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_AmountAvl
                      }
                      :{" "}
                    </p>
                    <Form.Group as={Row}>
                      <Form.Label
                        column
                        sm="2"
                        className="virtual_exchange_information_wallets_text"
                      >
                        {
                          this.props.traductions.wallets.Index.modalTransfers
                            .L_Amount
                        }
                      </Form.Label>
                      <Col sm="10" className="virtual_exchange_dropdown">
                        <div
                          className="input-signup"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <NumberFormat
                            disabled
                            className="btc-format-input"
                            placeholder={
                              this.props.traductions.wallets.Index
                                .modalTransfers.P_Amount
                            }
                            decimalScale={2}
                            thousandSeparator={true}
                            prefix={"$"}
                            value={this.state.amountW}
                            onValueChange={(values) => {
                              const { formattedValue, value } = values;
                              this.cryptoSend(value);
                            }}
                          />
                          <Button
                            disabled
                            variant="link"
                            className={"boton-seleccionar-currency"}
                          >
                            -
                          </Button>
                          <Button
                            className={
                              this.state.selectedCurrency === "usd"
                                ? "boton-seleccionar-currency-selected"
                                : "boton-seleccionar-currency"
                            }
                            variant="link"
                            onClick={() => {
                              this.setState({ selectedCurrency: "usd" });
                            }}
                          >
                            USD
                          </Button>
                        </div>
                      </Col>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row>
                <Col sm={{ span: 8, offset: 2 }}>
                  <Form.Group
                    as={Row}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Form.Label
                      column
                      sm="2"
                      className="virtual_exchange_information_wallets_text"
                    >
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_WalletPass
                      }
                    </Form.Label>
                    <Col sm="10" className="virtual_exchange_dropdown">
                      <Form.Control
                        type="password"
                        placeholder={
                          this.props.traductions.wallets.Index.modalTransfers
                            .P_WalletPass
                        }
                        value={this.state.passwordW}
                        onChange={(passwordW) => {
                          this.setState({ passwordW: passwordW.target.value });
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button
                  onClick={() => {
                    this.sendTransfer();
                  }}
                  className="signup-button"
                  variant="primary"
                  disabled={this.state.showLoad}
                >
                  {this.state.showload ? (
                    <Bounce
                      size={20}
                      color={"#FFFFFF"}
                      animating={this.state.showload}
                    />
                  ) : (
                    this.props.traductions.wallets.Index.modalTransfers.btn
                  )}
                </Button>
              </div>
            </div>
          </div>
        );
        break;
      case "external":
        return (
          <div className="container-steps-add-wallet-general">
            <div>
              <div>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image src={logoPlano} style={{ width: "25%" }} />
                </Row>
                {/* <p className="virtual_exchange_information_wallets_text" style={{marginBottom:'1.2em', fontWeight:'600'}}>Punto el que lo lea</p> */}
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "baseline",
                    marginTop: 20,
                  }}
                >
                  <Col md={6} className="virtual_exchange_dropdown">
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_FromWallets
                      }
                      :
                    </Form.Label>
                    <Dropdown
                      title={
                        this.state.fromWallet
                          ? this.state.fromWallet.alias
                          : this.props.traductions.wallets.Index.modalTransfers
                              .S_Wallets
                      }
                    >
                      <Dropdown.Toggle id="dropdown-custom-1">
                        {this.state.fromWallet ? (
                          <>
                            <Image
                              src={require("../../CryptoIcons/" +
                                this.state.fromWallet.coin +
                                ".svg")}
                              style={{
                                width: 15,
                                marginTop: -4,
                                marginRight: 5,
                              }}
                            />
                            {this.state.fromWallet.alias}:{" "}
                            <label
                              style={{ fontWeight: "bold", marginBottom: 0 }}
                            >
                              {Number(this.state.fromWallet.balance).toFixed(8)}{" "}
                            </label>{" "}
                            <label
                              style={{
                                textTransform: "uppercase",
                                marginBottom: 0,
                              }}
                            >
                              {this.state.fromWallet.coin}
                            </label>
                          </>
                        ) : (
                          this.props.traductions.wallets.Index.modalTransfers
                            .S_Wallets
                        )}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>{this.renderListWallets()}</Dropdown.Menu>
                    </Dropdown>
                  </Col>

                  {this.state.fromWallet && this.props.planInfo ? (
                    <Col md={6} className="virtual_exchange_dropdown">
                      <Form.Label
                        style={{
                          width: "100%",
                          margin: "-4px 0px",
                          paddingTop: "17px",
                        }}
                      >
                        <p
                          className="virtual_exchange_information_wallets_text"
                          style={{ float: "left" }}
                        >
                          {
                            this.props.traductions.wallets.Index.modalTransfers
                              .L_Amount
                          }
                        </p>
                        <p
                          className="text-available-modal"
                          style={{ float: "right" }}
                        >
                          Available: {this.state.fromWallet.balance}{" "}
                          {this.state.fromWallet.coin}
                        </p>
                      </Form.Label>
                      <Form.Group as={Row}>
                        <Col className="virtual_exchange_dropdown">
                          <div
                            className="input-signup"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {this.state.selectedCurrency == "usd" ? (
                              <NumberFormat
                                className="btc-format-input"
                                placeholder={
                                  this.props.traductions.wallets.Index
                                    .modalTransfers.P_Amount
                                }
                                decimalScale={2}
                                thousandSeparator={true}
                                prefix={"$"}
                                value={this.state.amountW}
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.cryptoSend(value);
                                }}
                              />
                            ) : (
                              <NumberFormat
                                className="btc-format-input"
                                placeholder={
                                  this.state.fromWallet.coin.toUpperCase() +
                                  " Amount"
                                }
                                decimalScale={8}
                                value={this.state.amountW}
                                onValueChange={(values) => {
                                  const { formattedValue, value } = values;
                                  this.cryptoSend(value);
                                }}
                              />
                            )}
                            <Button
                              className={
                                this.state.selectedCurrency ===
                                this.state.fromWallet.coin
                                  ? "boton-seleccionar-currency-selected"
                                  : "boton-seleccionar-currency"
                              }
                              variant="link"
                              onClick={() => {
                                this.setState({
                                  selectedCurrency: this.state.fromWallet.coin,
                                });
                              }}
                            >
                              {this.state.fromWallet.coin.toUpperCase()}
                            </Button>
                            <Button
                              className={
                                this.state.selectedCurrency === "usd"
                                  ? "boton-seleccionar-currency-selected"
                                  : "boton-seleccionar-currency"
                              }
                              variant="link"
                              onClick={() => {
                                this.setState({ selectedCurrency: "usd" });
                              }}
                            >
                              USD
                            </Button>
                          </div>
                          <div
                            className={
                              this.state.amountW
                                ? "container-addresses-label"
                                : "container-addresses-label-error"
                            }
                          >
                            <p
                              className={
                                !this.state.amountW
                                  ? "label-addresses-captured-success"
                                  : "label-addresses-captured-warning"
                              }
                              style={{ marginBottom: 2 }}
                            >
                              {
                                this.props.traductions.wallets.Index
                                  .modalTransfers.N_Amount1
                              }{" "}
                              {this.calculateCryptoAccount() *
                                this.state.accountFee}{" "}
                              {this.state.fromWallet.coin} (
                              {Number(
                                this.props.planInfo.transfer_users_web
                              ).toFixed(0)}
                              %{" "}
                              {
                                this.props.traductions.wallets.Index
                                  .modalTransfers.N_Amount2
                              }
                              )
                            </p>
                            <p
                              className={
                                !this.state.amountW
                                  ? "label-addresses-captured-success"
                                  : "label-addresses-captured-warning"
                              }
                            >
                              {
                                this.props.traductions.wallets.Index
                                  .modalTransfers.N_Amount3
                              }{" "}
                              {this.calculateUSDAccount()} usd
                            </p>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  ) : (
                    <Col md={6} className="virtual_exchange_dropdown">
                      <Form.Label
                        style={{
                          width: "100%",
                          margin: "-4px 0px",
                          paddingTop: "17px",
                        }}
                      >
                        <p
                          className="virtual_exchange_information_wallets_text"
                          style={{ float: "left" }}
                        >
                          {
                            this.props.traductions.wallets.Index.modalTransfers
                              .L_Amount
                          }
                        </p>
                        <p
                          className="text-available-modal"
                          style={{ float: "right" }}
                        >
                          {
                            this.props.traductions.wallets.Index.modalTransfers
                              .L_AmountAvl
                          }
                          : {this.state.fromWallet.balance}{" "}
                          {this.state.fromWallet.coin}
                        </p>
                      </Form.Label>
                      <Form.Group as={Row}>
                        <Col className="virtual_exchange_dropdown">
                          <div
                            className="input-signup"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <NumberFormat
                              disabled
                              className="btc-format-input"
                              placeholder={
                                this.props.traductions.wallets.Index
                                  .modalTransfers.P_Amount
                              }
                              decimalScale={2}
                              thousandSeparator={true}
                              prefix={"$"}
                              value={this.state.amountW}
                              onValueChange={(values) => {
                                const { formattedValue, value } = values;
                                this.cryptoSend(value);
                              }}
                            />
                            <Button
                              disabled
                              variant="link"
                              className={"boton-seleccionar-currency"}
                            >
                              -
                            </Button>
                            <Button
                              disabled
                              className={
                                this.state.selectedCurrency === "usd"
                                  ? "boton-seleccionar-currency-selected"
                                  : "boton-seleccionar-currency"
                              }
                              variant="link"
                              onClick={() => {
                                this.setState({ selectedCurrency: "usd" });
                              }}
                              style={{ cursor: "no-drop" }}
                            >
                              USD
                            </Button>
                          </div>
                        </Col>
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col md={6} className="virtual_exchange_dropdown">
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_Desc
                      }
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.Index.modalTransfers
                          .P_Desc
                      }
                      maxlength="64"
                      value={this.state.description}
                      onChange={(description) => {
                        this.setState({
                          description: description.target.value,
                        });
                      }}
                    />
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {this.state.description.length}/64
                    </Form.Label>
                  </Col>

                  <Col md={6} className="virtual_exchange_dropdown">
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_Pass
                      }
                    </Form.Label>
                    <Form.Control
                      type="password"
                      placeholder={
                        this.props.traductions.wallets.Index.modalTransfers
                          .P_Pass
                      }
                      value={this.state.passwordW}
                      onChange={(passwordW) => {
                        this.setState({ passwordW: passwordW.target.value });
                      }}
                    />
                  </Col>
                </Row>
                <hr style={{ marginTop: "2em", marginBottom: "1em" }} />
                <Row className="arrowDown">
                  <div>
                    <Image src={arrowDown} />
                  </div>
                </Row>
                {/* <p className="virtual_exchange_information_wallets_text" style={{marginBottom:'1.2em', fontWeight:'600', marginTop:'1em'}}>Punto el que lo lea</p> */}
                <Row>
                  <Col md={6} className="virtual_exchange_dropdown">
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_Alias
                      }
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.Index.modalTransfers
                          .P_Alias
                      }
                      value={this.state.toAccount}
                      onChange={(toAccount) => {
                        this.setState({ toAccount: toAccount.target.value });
                      }}
                    />
                  </Col>
                  <Col md={6} className="virtual_exchange_dropdown">
                    <Form.Label className="virtual_exchange_information_wallets_text">
                      {
                        this.props.traductions.wallets.Index.modalTransfers
                          .L_WAlias
                      }
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={
                        this.props.traductions.wallets.Index.modalTransfers
                          .P_WAlias
                      }
                      value={this.state.toAlias}
                      onChange={(toAlias) => {
                        this.setState({ toAlias: toAlias.target.value });
                      }}
                    />
                  </Col>
                </Row>
              </div>
              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button
                  onClick={() => {
                    // this.verifyTwofa();
                    this.handleoGoToConfirmTransfer();
                  }}
                  className="signup-button"
                  variant="primary"
                  disabled={this.state.showLoad}
                >
                  {this.state.showload ? (
                    <Bounce
                      size={20}
                      color={"#FFFFFF"}
                      animating={this.state.showload}
                    />
                  ) : (
                    this.props.traductions.wallets.Index.modalTransfers.btn
                  )}
                </Button>
              </div>
            </div>
          </div>
        );
        break;

      case "external_confirmation":
        return (
          <ExternalTransferConfirmation
            traductions={this.props.traductions}
            fromWallet={this.state.fromWallet}
            toAccount={this.state.toAccount}
            toAlias={this.state.toAlias}
            description={this.state.description}
            showLoad={this.state.showload}
            onClose={() => this.setState({ tab: "external" })}
            amountW={this.state.amountW}
            cryptoSend={this.state.cryptoSend}
            formatMoney={formatMoney}
            moneyFromCrypto={this.calculateUSDAccount()}
            selectedCurrency={this.state.selectedCurrency}
            handleSubmit={() => this.verifyTwofa()}
          />
        );
        break;

      default:
    }
  }

  render() {
    return (
      <Modal
        className={
          this.state.showModalTwofa === false
            ? "modal-transfer"
            : "modal-transfer-twofa"
        }
        centered
        aria-labelledby="contained-modal-title-vcenter"
        show={this.props.showModalTransfer}
        onHide={() => {
          this.props.handleClose();
          this.props.data.history.push("/wallets");
        }}
      >
        <Modal.Body>
          {this.state.showModalTwofa === false ? (
            <Row>
              <OverlayTrigger
                placement={"top"}
                overlay={
                  <Tooltip>
                    {
                      this.props.traductions.wallets.Index.modalTransfers
                        .t_i_tooltip
                    }
                  </Tooltip>
                }
              >
                <Col
                  className={
                    this.state.tab == "internal"
                      ? "transfer-tab selected"
                      : "transfer-tab"
                  }
                  onClick={() => this.setState({ tab: "internal" })}
                >
                  {
                    this.props.traductions.wallets.Index.modalTransfers
                      .Tab_interna
                  }
                </Col>
              </OverlayTrigger>

              <OverlayTrigger
                placement={"top"}
                overlay={
                  <Tooltip>
                    {
                      this.props.traductions.wallets.Index.modalTransfers
                        .t_e_tooltip
                    }
                  </Tooltip>
                }
              >
                <Col
                  className={
                    this.state.tab == "external" ||
                    this.state.tab == "external_confirmation"
                      ? "transfer-tab selected"
                      : "transfer-tab"
                  }
                  onClick={() => this.setState({ tab: "external" })}
                >
                  {
                    this.props.traductions.wallets.Index.modalTransfers
                      .Tab_externa
                  }
                </Col>
              </OverlayTrigger>
            </Row>
          ) : (
            <Modaltwofa TowFAConfirm={this.TowFAConfirm} />
          )}
          {this.state.showModalTwofa === false && this.contentManager()}
        </Modal.Body>
      </Modal>
    );
  }
}
